module.exports = __webpack_public_path__ + "static/img/far1_active.ea6619bc.png";